// @flow

export const orgsOrUser = Object.freeze({
  ByOrgs: 'by_orgs',
  ByUser: 'by_user',
});

export type OrgsOrUser = $Values<typeof orgsOrUser>
